export const CREATE = {
  REQUEST: 'CatalogItem/Create/Request',
  SUCCESS: 'CatalogItem/Create/Success',
  FAILURE: 'CatalogItem/Create/Failure'
};

export const GET = {
  REQUEST: 'CatalogItem/Get/Request',
  SUCCESS: 'CatalogItem/Get/Success',
  FAILURE: 'CatalogItem/Get/Failure'
};

export const CLEAR = {
  REQUEST: 'CatalogItem/Clear/Request',
  SUCCESS: 'CatalogItem/Clear/Success',
  FAILURE: 'CatalogItem/Clear/Failure'
};

export const EDIT = {
  REQUEST: 'CatalogItem/Edit/Request',
  SUCCESS: 'CatalogItem/Edit/Success',
  FAILURE: 'CatalogItem/Edit/Failure'
};

export const DELETE = {
  REQUEST: 'CatalogItem/Delete/Request',
  SUCCESS: 'CatalogItem/Delete/Success',
  FAILURE: 'CatalogItem/Delete/Failure'
};

export const FORSUBMIT = {
  REQUEST: 'CatalogItem/ForSubmit/Request',
  SUCCESS: 'CatalogItem/ForSubmit/Success',
  FAILURE: 'CatalogItem/ForSubmit/Failure'
};
